module.exports = __webpack_public_path__ + "static/media/rsvpSocial.75b9b4b8.png";